

















































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import MemberKey from "@/components/member-key";
import SupportKey from "@/components/support-key";
import _ from "lodash";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }

    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }
    const supportStore = inject(SupportKey);
    if (!supportStore) {
      throw new Error(`${SupportKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);

    const member = computed(() => memberStore.member);

    const inquiryParams = computed(() => supportStore.inquiryParams);
    const selectedInquiryTypeName = computed(
      () => supportStore.selectedInquiryTypeName
    );
    const inquiryReceiptNumber = computed(
      () => supportStore.inquiryReceiptNumber
    );

    const loading = computed(() => displayuiStore.loading);
    const openOverlayLoading = displayuiStore.openOverlayLoading;
    const closeOverlayLoading = displayuiStore.closeOverlayLoading;

    const send = async () => {
      openOverlayLoading();
      supportStore.setAuthorizationHeader(accessToken.value);
      supportStore.clearInquiryReceiptNumber();
      await supportStore.postInquiry();
      closeOverlayLoading();
      if (inquiryReceiptNumber.value) {
        supportStore.clearInquiryParams();
        supportStore.clearSelectedInquiryTypeName();
        context.root.$router.push({ name: "MemberFaqInquiryComplete" });
      }
    };

    onMounted(async () => {
      if (!("card_number" in member.value)) {
        context.root.$router.push({ name: "MemberFaqInquiry" });
      }
    });

    return {
      loading,
      member,
      inquiryParams,
      selectedInquiryTypeName,
      send
    };
  },
  components: {}
});
